import React from 'react';
import AsyncTable from 'components/v2/AsyncTable';

export default function AgentClientTable(props) {
  const { data = [], columns = [], noResultsText = 'No clients found' } = props;
  return <AsyncTable async={false} columns={columns} data={data} count={data.length} noResultsText={noResultsText} />;
}
